import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';
import ProjectDetail from '../components/ProjectDetail';
import { getProjectBySlug } from '../data/projects';

const DEFAULT_TITLE = 'Samet Aslan - Full-Stack Developer';
const DEFAULT_DESCRIPTION =
  'Samet Aslan - Full-Stack Developer building practical software, automation, and mobile apps.';

function ProjectPage({ match }) {
  const project = getProjectBySlug(match.params.slug);

  useEffect(() => {
    if (!project) {
      return undefined;
    }

    document.title = `${project.title} · Samet Aslan`;
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute('content', project.metaDescription || project.description);
    }

    return () => {
      document.title = DEFAULT_TITLE;
      if (metaTag) {
        metaTag.setAttribute('content', DEFAULT_DESCRIPTION);
      }
    };
  }, [project]);

  if (!project) {
    return <Redirect to="/" />;
  }

  return <ProjectDetail project={project} />;
}

export default ProjectPage;
